import i18n from '../i18n';

export default class BoxSizeType {
  public static readonly SIZE_100 = new BoxSizeType('1', '100サイズ');
  public static readonly SIZE_120 = new BoxSizeType('2', '120サイズ');
  public static readonly SIZE_140 = new BoxSizeType('3', '140サイズ');
  // public static readonly SIZE_160_A = new BoxSizeType('4', '160Aサイズ');
  public static readonly SIZE_160_B = new BoxSizeType('5', '160Bサイズ');
  public static readonly SIZE_DHL_7 = new BoxSizeType('6', 'DHL7サイズ');
  public static readonly SIZE_DHL_6 = new BoxSizeType('7', 'DHL6サイズ');
  public static readonly SIZE_DHL_8 = new BoxSizeType('8', 'DHL8サイズ');
  public static readonly SIZE_MATOME = new BoxSizeType('9', '特殊便用');
  public static readonly SIZE_LIST_WATCH = new BoxSizeType('10', '【腕時計用】');
  public static readonly SIZE_DHL_5 = new BoxSizeType('11', 'DHL5サイズ');
  public static readonly SIZE_UPS_TOKUSYU = new BoxSizeType('12', 'UPS特殊');
  public static readonly SIZE_SIZE7 = new BoxSizeType('13', 'SIZE7サイズ');
  public static readonly SIZE_NONE = new BoxSizeType('99', '-');

  public static values(): any {
    return [
      { value: this.SIZE_100.value, text: i18n.t(this.SIZE_100.text) },
      { value: this.SIZE_120.value, text: i18n.t(this.SIZE_120.text) },
      { value: this.SIZE_140.value, text: i18n.t(this.SIZE_140.text) },
      { value: this.SIZE_160_B.value, text: i18n.t(this.SIZE_160_B.text) },
      { value: this.SIZE_DHL_5.value, text: i18n.t(this.SIZE_DHL_5.text) },
      { value: this.SIZE_DHL_6.value, text: i18n.t(this.SIZE_DHL_6.text) },
      { value: this.SIZE_DHL_7.value, text: i18n.t(this.SIZE_DHL_7.text) },
      { value: this.SIZE_DHL_8.value, text: i18n.t(this.SIZE_DHL_8.text) },
      { value: this.SIZE_SIZE7.value, text: i18n.t(this.SIZE_SIZE7.text) },
      { value: this.SIZE_MATOME.value, text: i18n.t(this.SIZE_MATOME.text) },
      { value: this.SIZE_LIST_WATCH.value, text: i18n.t(this.SIZE_LIST_WATCH.text) },
      { value: this.SIZE_NONE.value, text: i18n.t(this.SIZE_NONE.text) },
    ];
  }

  public static filterValues(): any {
    return [
      { value: this.SIZE_100.value, text: i18n.t(this.SIZE_100.text) },
      { value: this.SIZE_120.value, text: i18n.t(this.SIZE_120.text) },
      { value: this.SIZE_140.value, text: i18n.t(this.SIZE_140.text) },
      { value: this.SIZE_160_B.value, text: i18n.t(this.SIZE_160_B.text) },
      { value: this.SIZE_DHL_5.value, text: i18n.t(this.SIZE_DHL_5.text) },
      { value: this.SIZE_DHL_6.value, text: i18n.t(this.SIZE_DHL_6.text) },
      { value: this.SIZE_DHL_7.value, text: i18n.t(this.SIZE_DHL_7.text) },
      { value: this.SIZE_DHL_8.value, text: i18n.t(this.SIZE_DHL_8.text) },
      { value: this.SIZE_SIZE7.value, text: i18n.t(this.SIZE_SIZE7.text) },
      { value: this.SIZE_MATOME.value, text: i18n.t(this.SIZE_MATOME.text) },
      { value: this.SIZE_LIST_WATCH.value, text: i18n.t(this.SIZE_LIST_WATCH.text) },
      { value: this.SIZE_NONE.value, text: i18n.t(this.SIZE_NONE.text) },
    ];
  }

  // public static valueOf(value: string): BoxSizeType {
  //   for (const v of this.values()) {
  //     if (v.value === value) {
  //       return v;
  //     }
  //   }
  //   return BoxSizeType.UNDEFINED;
  // }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: BoxSizeType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
